module.exports = __webpack_public_path__ + "images/erp-nation-glad-bottom.1789545008192.png";